
import { previousRoute } from '@/router/history'

export function useBackRoute(){

    const getBackRoute = (key, defaultRoute) => {

        if(previousRoute.value[key] === undefined) {
            return defaultRoute
        }

        if(previousRoute.value[key].fullPath === '/'){
            return defaultRoute
        }
    
        return previousRoute.value[key].query
    }

    return {
        getBackRoute
    }
}